import { createRouter } from "@tanstack/react-router";
import { caseLayoutRoute } from "./routes/cases/case-layout-route";
import { caseJsonEditsRoute } from "./routes/cases/case-json-edits-route";
import { caseSettingsRoute } from "./routes/cases/case-settings-route";
import {
  caseSourceRoute,
  caseUploadRedirectRoute,
} from "./routes/cases/case-source-route";
import { caseVersionsRoute } from "./routes/cases/case-versions-route";
import { versionAgentRoute } from "./routes/cases/version-agent-route";
import { versionAssetsRoute } from "./routes/cases/version-assets-route";
import { versionLayoutRoute } from "./routes/cases/version-layout-route";
import { versionMetaRoute } from "./routes/cases/version-meta-route";
import { versionPipelineRoute } from "./routes/cases/version-pipeline-route";
import { versionPreviewRoute } from "./routes/cases/version-preview-route";
import { versionPublishRoute } from "./routes/cases/version-publish-route";
import { versionTranslateRoute } from "./routes/cases/version-translate-route";
import { casesNewRoute } from "./routes/cases-new-route";
import { extractRoute } from "./routes/extract-route";
import { indexRoute } from "./routes/index-route";
import { loginRoute } from "./routes/login-route";
import { phoneRuntimeRoute } from "./routes/phone-runtime-route";
import { rootRoute } from "./routes/root-route";
import { scriptCheckRoute } from "./routes/script-check-route";
import { userGroupsRoute } from "./routes/user-groups-route";
import { usersRoute } from "./routes/users-route";

const versionRouteTree = versionLayoutRoute.addChildren([
  versionMetaRoute,
  versionPipelineRoute,
  versionTranslateRoute,
  versionPreviewRoute,
  versionPublishRoute,
  versionAgentRoute,
  versionAssetsRoute,
]);

const caseRouteTree = caseLayoutRoute.addChildren([
  caseVersionsRoute,
  caseSourceRoute,
  caseUploadRedirectRoute,
  caseJsonEditsRoute,
  caseSettingsRoute,
  versionRouteTree,
]);

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  casesNewRoute,
  extractRoute,
  scriptCheckRoute,
  phoneRuntimeRoute,
  usersRoute,
  userGroupsRoute,
  caseRouteTree,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
